
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
  Search,
  Grid,
  Input,
  Icon,
} from 'semantic-ui-react';
import { flashErrorMessage } from '../actions/flash';
import { namespaces, TRANSLATION_FILES } from './../constants/translation';
import { fetchM } from '../actions/fetchM';
import { staffSearchQuery } from '../utils/vietnam';

class SearchStaff extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    selectedValue: PropTypes.shape({
      key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      price: PropTypes.string.isRequired,
    }).isRequired,
    value: PropTypes.string,
    searchAll: PropTypes.bool,
    // CPI-1429: Vietnamese sale whose assigned agent's branch limits the results; needs auth.
    bookingID: PropTypes.string,
    auth: PropTypes.shape({ company: PropTypes.shape({ countryCode: PropTypes.string }) }),
    disabled: PropTypes.bool,
    onFetch: PropTypes.func,
    placeholder: PropTypes.string,
    t: PropTypes.func,
  }
  static defaultProps = {
    selectedValue: {
      key: 0,
      title: '',
      price: '',
    },
    disabled: false,
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const noResultsMessage = 'Loading...';
    return {
      value,
      noResultsMessage,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchStaff.getPropsToState(props);
    this.state = {
      ...state,
      findStaffsResults: [],
      loading: false,
      showNoResults: true,
      selection: null,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchStaff.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  async searchStaffs(value) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    let res = null;
    try {
      const query = staffSearchQuery({
        auth: this.props.auth,
        searchAll: this.props.searchAll,
        search: value,
        bookingID: this.props.bookingID,
      });
      res = await store.dispatch(fetchM(`/search/staffs/?${query}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      if (json) {
        const findStaffsResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.name;
          newResults.price = obj.preferredName;
          newResults.description = obj.email;
          return newResults;
        });
        await this.setComponentState({ findStaffsResults }, () => {
          if (this.props.onFetch) {
            this.props.onFetch(json, this.state.value);
          }
        });
      } else {
        const noResultsMessage = t('No results found', { ns: TRANSLATION_FILES.translation });
        await this.setComponentState({ noResultsMessage });
      }
    }
    await this.setLoading(false);
  }
  handleSearchChange = (e, { value }) => {
    const { t } = this.props;
    clearTimeout(this.setTimer);
    const findStaffsResults = [];
    const showNoResults = true;
    const noResultsMessage = t('Loading...', { ns: TRANSLATION_FILES.translation });
    this.setState({ findStaffsResults, noResultsMessage, showNoResults, value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchStaffs(value);
        }, 500);
      }
    });
  }
  handleResultSelect = (e, { result }) => {
    this.setState({
      selection: result,
      value: '',
    }, () => {
      this.props.onSelect(result);
    });
  }
  handleClearSelection = () => {
    this.setState({
      selection: null,
    }, () => {
      this.props.onClear();
    });
  }
  handlerClearValue = () => {
    this.setState({
      value: '',
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            { this.props.selectedValue.key > 0 || this.state.selection ?
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Input
                      readOnly
                      fluid
                      disabled={this.props.disabled}
                      value={
                        this.props.selectedValue.key > 0
                        ? `${this.props.selectedValue.title} ${this.props.selectedValue.price && `(${this.props.selectedValue.price})`}`
                        : `${this.state.selection.title} ${this.state.selection.price && `(${this.state.selection.price})`}`
                      }
                      icon={
                        <Icon
                          title="Clear Selection"
                          name="x"
                          onClick={this.handleClearSelection}
                          link
                        />
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            :
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Search
                      className="searchlist"
                      disabled={this.props.disabled}
                      fluid
                      icon={
                        <Icon
                          title="Clear Selection"
                          name={this.state.value ? 'x' : 'search'}
                          onClick={this.state.value && this.handlerClearValue}
                          link={!!this.state.value}
                        />
                      }
                      loading={this.state.loading}
                      onResultSelect={this.handleResultSelect}
                      onSearchChange={this.handleSearchChange}
                      results={this.state.findStaffsResults}
                      value={this.state.value}
                      placeholder={this.props.placeholder || t('Find Staff...', { ns: TRANSLATION_FILES.translation })}
                      noResultsMessage={this.state.noResultsMessage}
                      onFocus={() => {
                        const showNoResults = false;
                        this.setState({ showNoResults });
                      }}
                      showNoResults={this.state.showNoResults}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(SearchStaff);



// WEBPACK FOOTER //
// ./src/components/SearchStaff.jsx